import { useEffect } from 'react';

import styles from './BannedAccountScreen.module.css';

export interface BanNotice {
  reason: string;
  expiresAt: string | null;
}

export function BannedAccountScreen({
  ban,
  isChecking,
  onRetry,
}: {
  ban: BanNotice;
  isChecking: boolean;
  onRetry: () => void;
}) {
  useEffect(() => {
    if (!ban.expiresAt) return;
    const interval = window.setInterval(() => {
      if (Date.now() >= Date.parse(ban.expiresAt!)) onRetry();
    }, 30_000);
    return () => window.clearInterval(interval);
  }, [ban.expiresAt, onRetry]);

  return (
    <div className={styles.wrap} role="alert">
      <p className={styles.emoji}>🚫</p>
      <p className={styles.title}>Account suspended</p>
      <p className={styles.body}>You cannot use YeneShop while this suspension is active.</p>
      <div className={styles.details}>
        <p><span>Reason</span><strong>{ban.reason}</strong></p>
        <p>
          <span>Duration</span>
          <strong>
            {ban.expiresAt
              ? `Until ${new Date(ban.expiresAt).toLocaleString()}`
              : 'Permanent'}
          </strong>
        </p>
      </div>
      <p className={styles.support}>Contact support if you believe this was a mistake.</p>
      <button type="button" className={styles.button} disabled={isChecking} onClick={onRetry}>
        {isChecking ? 'Checking…' : 'Check access again'}
      </button>
    </div>
  );
}
